
















































































































import { Component, Prop, Watch } from "vue-property-decorator";
import _ from "lodash";

import { WorkshopModel, CompanyModel, UserSearchModel } from "@/core/models";
import { ConfirmDialogCpt } from "@/core/components";
import { WorkshopService, UserService } from "@/core/services";
import { WorkshopStatus } from "@/core/constants";
import { WorkshopFacilitatorUpdateCpt, WorkshopStatusCpt } from "./";

import AppVue from "@/AppVue.vue";
import EditWorkshopFormCpt from "./EditWorkshopFormCpt.vue";

@Component({
  components: {
    ConfirmDialogCpt,
    WorkshopFacilitatorUpdateCpt,
    WorkshopStatusCpt,
    EditWorkshopFormCpt,
  },
})
export default class WorkshopDetailHeaderCpt extends AppVue {
  @Prop() model: WorkshopModel;
  @Prop({ default: false }) loading: boolean;
  @Prop({ default: true }) isEdit: boolean;
  @Prop({ default: true }) isDelete: boolean;
  showDeleteDialog = false;
  showEditDialog = false;
  internalLoading = false;

  get canComplete() {
    return this.model.workshopStatusId !== WorkshopStatus.Complete && (this.isImi || this.isDovetail);
  }

  private editWorkshopSuccess(newModel: WorkshopModel) {
    this.showEditDialog = false;
    this.$emit("workshop-updated");
  }

  private closeEditDialog() {
    this.showEditDialog = false;
  }

  private deleteCompany() {
    this.showDeleteDialog = true;
  }

  private editWorkshop() {
    this.showEditDialog = true;
  }

  private deleteWorkshop() {
    this.showDeleteDialog = true;
  }

  private workshopUpdated() {
    this.$emit("workshop-updated");
  }

  private async setAsComplete() {
    this.internalLoading = true;
    try {
      const model = await WorkshopService.completeWorkshop(this.model.id);
      this.workshopUpdated();
      this.notify("Success", "Workshop successfully updated", "success");
    } catch (err) {
      this.notify("Error", "Something went wrong while updating workshop", "error");
    } finally {
      this.internalLoading = false;
    }
  }

  private async closeConfirm(result: boolean) {
    this.showDeleteDialog = false;
    this.internalLoading = true;
    try {
      if (result === true) {
        await WorkshopService.deleteWorkshop(this.model.id);
        this.notify("Success", "Workshop successfully deleted", "success");
        this.$router.push("/admin/workshops");
      }
    } catch (err) {
      this.notify("Error", "Something went wrong while deleting workshop", "error");
    } finally {
      this.internalLoading = false;
    }
  }
}
